// 9fbef606107a605d69c0edbcd8029e5d
import { getLabelValue } from '@tcp/core/src/utils/utils';
import {
  lblHeadingStorePickUp,
  lblHeadingStorePickUpExpired,
  lblNotificationCancelledItems,
  lblNotificationOrderPicked1,
  lblOrderNotPicked2,
} from '../../../../OrderDetails/container/OrderDetails.labels';
import { getLabelWithDefaultValue } from '../../../../../../../utils/labels/labelUtilty';

const messageLabel = (isEcomOrder, hasExpiredItems = false) => {
  if (isEcomOrder) {
    return lblNotificationCancelledItems;
  }
  return hasExpiredItems ? lblNotificationOrderPicked1 : lblNotificationCancelledItems;
};

export const getMessageBoldText = (orderLabels, isEcomOrder, hasExpiredItems = false) =>
  getLabelValue(orderLabels, messageLabel(isEcomOrder, hasExpiredItems));

export const getMessageNormalText = (orderLabels, isEcomOrder, hasExpiredItems) => {
  if (isEcomOrder) {
    return '';
  }
  return hasExpiredItems ? getLabelValue(orderLabels, lblOrderNotPicked2) : '';
};

export const getOrderTypeText = (orderLabels, isEcomOrder, expiredItemShipment, shippingLbl) => {
  let orderTypeText = isEcomOrder
    ? shippingLbl
    : getLabelWithDefaultValue(orderLabels, lblHeadingStorePickUp);
  if (!isEcomOrder && expiredItemShipment) {
    orderTypeText = getLabelWithDefaultValue(orderLabels, lblHeadingStorePickUpExpired);
  }
  return orderTypeText;
};
